<div id="welcome-dialog-container" class="modal-dialog">
  <div class="modal-content">
    <div class="goreact-modal-body" cdkTrapFocus>
      @if ((step$ | async) === welcomeStepsState.WELCOME) {
        <welcome-step (onProceed)="continue()" [data]="data" [showSelfPayStep]="showSelfPayStep" [showFreeTrialStep]="hasFreeTrialLicense" [loading$]="showLoadingIndicator$"></welcome-step>
      }
      @if ((step$ | async) === welcomeStepsState.CHOOSE_PLAN) {
        <choose-plan (onBack)="back()" (onSelfPay)="close({selfPay: true})" (onStudentPay)="close({selfPay: false})"></choose-plan>
      }
    </div>
  </div>
</div>
